import React from "react";

const ChargingStationClusterMarker = ({
  cluster: {
    properties: {
      point_count: pointCount
    }
  },
  onClick,
}) => {
  return (
    // onClick is also forwarded to the AdvancedMarker by wrapPositionedChildren,
    // since AdvancedMarker does not propagate DOM clicks from custom content.
    <div className="google-map-cluster-marker" onClick={onClick}>
      <span className="text"> {pointCount}</span>
    </div>
  );
};

export default ChargingStationClusterMarker;
